const NO_RESULT_MARKERS = new Set([
  "there were no results found",
  "no results found",
  "no result found",
]);

export function hasStructuredCustomsSnapshot(data) {
  return Boolean(data?.customs_checks?.snapshot?.snapshotId);
}

export function structuredCustomsItems(data) {
  return Array.isArray(data?.customs_checks?.items) ? data.customs_checks.items : [];
}

/**
 * The structured 0205 snapshot is authoritative for 세관장확인. Keep every other
 * legacy section, but remove the compatibility customs rows to prevent double render.
 * Before the first active snapshot, keep the legacy payload unchanged.
 */
export function displayLegacyRequirements(data) {
  const req = data?.requirements;
  if (!req || typeof req !== "object" || Array.isArray(req)) return req || null;
  const authoritative = hasStructuredCustomsSnapshot(data);
  const filter = (items) =>
    Array.isArray(items)
      ? items.filter((item) => !authoritative || item?.label !== "세관장확인")
      : [];
  const other = String(req.other || "")
    .trim()
    .toLowerCase()
    .replace(/[.!]+$/, "")
    .trim();
  const out = {
    ...req,
    import: filter(req.import),
    export: filter(req.export),
  };
  if (NO_RESULT_MARKERS.has(other)) delete out.other;
  return out;
}

export function customsChecksByDirection(data) {
  return structuredCustomsItems(data).reduce(
    (groups, item) => {
      const direction = item?.direction === "export" ? "export" : "import";
      groups[direction].push(item);
      return groups;
    },
    { import: [], export: [] },
  );
}
